import React, { useEffect, useState } from "react";
import { FiCamera, FiPlus, FiSearch } from "react-icons/fi";
import MenuLateral from "../../Components/MenuLateral";
import CadastroPageHeader, { CadastroPanelHeading } from "../../Components/CadastroPageHeader";
import api from "../../services/api";
import { showApiError } from "../../services/showApiError";
import CepAddressLookup from "../../Components/CepAddressLookup";
import FieldLabel from "../../Components/FieldLabel";
import Swal from "sweetalert2";
import "./index.css";
import "../../styles/cadastro-pages.css";

const senhaPadrao = {
  password: "",
  passwordConfirmation: "",
};

function CadFotografo() {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [cpf, setCpf] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [phone, setPhone] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(true);
  const [passwords, setPasswords] = useState({ ...senhaPadrao });

  const [zipCode, setZipCode] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [uf, setUf] = useState("");

  const [lista, setLista] = useState([]);
  const [search, setSearch] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [loading, setLoading] = useState(false);

  const aplicarEnderecoPorCep = (address) => {
    setStreet(address.street);
    setDistrict(address.district);
    setCity(address.city);
    setUf(address.uf);
  };

  const carregarFotografos = async () => {
    setLoading(true);
    try {
      const resp = await api.get("/users", {
        params: {
          role: "PHOTOGRAPHER",
          name: search || undefined,
          includeInactive,
          limit: 100,
        },
      });
      const users = resp.data?.found?.users || resp.data?.users || [];
      setLista(users.filter((user) => user.role === "PHOTOGRAPHER"));
    } catch (err) {
      showApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarFotografos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeInactive]);

  const limpar = () => {
    setId("");
    setName("");
    setNickname("");
    setCpf("");
    setBirthDate("");
    setPhone("");
    setMobilePhone("");
    setEmail("");
    setStatus(true);
    setPasswords({ ...senhaPadrao });
    setZipCode("");
    setStreet("");
    setNumber("");
    setComplement("");
    setDistrict("");
    setCity("");
    setUf("");
  };

  const selecionar = (fotografo) => {
    setId(fotografo.id);
    setName(fotografo.name || "");
    setNickname(fotografo.nickname || "");
    setCpf(fotografo.cpf || "");
    setBirthDate(fotografo.birthDate?.substring(0, 10) || "");
    setPhone(fotografo.phone || "");
    setMobilePhone(fotografo.mobilePhone || "");
    setEmail(fotografo.email || "");
    setStatus(fotografo.status !== false);
    setPasswords({ ...senhaPadrao });
    setZipCode(fotografo.zipCode || "");
    setStreet(fotografo.street || "");
    setNumber(fotografo.number || "");
    setComplement(fotografo.complement || "");
    setDistrict(fotografo.district || "");
    setCity(fotografo.city || "");
    setUf(fotografo.uf || "");

    const el = document.querySelector(".form-cad");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const salvar = async () => {
    if (!name.trim() || !email.trim()) {
      Swal.fire("Dados obrigatorios", "Informe nome e e-mail.", "warning");
      return;
    }

    if (!id && (!passwords.password || !passwords.passwordConfirmation)) {
      Swal.fire("Senha obrigatoria", "Informe e confirme a senha inicial.", "warning");
      return;
    }

    const payload = {
      name: name.trim(),
      nickname: nickname || undefined,
      cpf: cpf || undefined,
      birthDate: birthDate || undefined,
      phone: phone || undefined,
      mobilePhone: mobilePhone || undefined,
      email: email.trim(),
      role: "PHOTOGRAPHER",
      zipCode: zipCode || undefined,
      street: street || undefined,
      number: number || undefined,
      complement: complement || undefined,
      district: district || undefined,
      city: city || undefined,
      uf: uf || undefined,
    };

    setLoading(true);
    try {
      if (id) {
        await api.patch(`/users/${id}`, {
          ...payload,
          status,
        });
        Swal.fire("Atualizado", "Fotografo atualizado com sucesso.", "success");
      } else {
        await api.post("/users", {
          ...payload,
          password: passwords.password,
          passwordConfirmation: passwords.passwordConfirmation,
        });
        Swal.fire("Cadastrado", "Fotografo cadastrado com sucesso.", "success");
      }

      limpar();
      await carregarFotografos();
    } catch (err) {
      showApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const alterarStatus = async (fotografo, nextStatus) => {
    const confirmation = await Swal.fire({
      title: nextStatus ? "Restaurar fotografo?" : "Inativar fotografo?",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    });
    if (!confirmation?.isConfirmed) return;

    setLoading(true);
    try {
      await api.patch(`/users/${fotografo.id}`, {
        status: nextStatus,
        role: "PHOTOGRAPHER",
      });
      Swal.fire("Atualizado", "Status do fotografo atualizado.", "success");
      if (id === fotografo.id) setStatus(nextStatus);
      await carregarFotografos();
    } catch (err) {
      showApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pagina-cad cadastro-shell cadastro-shell-fotografos">
      <MenuLateral />

      <div className="conteudo-cad">
        <CadastroPageHeader
          eyebrow="Cadastros / Equipe"
          title="Fotógrafos"
          description="Gerencie os profissionais que poderão receber eventos e conduzir a operação de fotos."
          icon={FiCamera}
          context="Equipe operacional"
          contextDetail="Acessos e vínculos sob controle"
        />

        <div className="form-cad">
          <CadastroPanelHeading
            eyebrow={id ? "Edição de cadastro" : "Novo cadastro"}
            title={id ? "Atualizar fotógrafo" : "Adicionar fotógrafo"}
            description="Use os dados de contato para identificar a pessoa e entregar o acesso correto."
            icon={id ? FiCamera : FiPlus}
          />
          <div className="row-form">
            <FieldLabel label="Nome">
              <input placeholder="Nome" value={name} onChange={(e) => setName(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="Apelido">
              <input placeholder="Apelido" value={nickname} onChange={(e) => setNickname(e.target.value)} disabled={loading} />
            </FieldLabel>
          </div>

          <div className="row-form">
            <FieldLabel label="CPF">
              <input placeholder="CPF" value={cpf} onChange={(e) => setCpf(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="Data de nascimento">
              <input type="date" value={birthDate} onChange={(e) => setBirthDate(e.target.value)} disabled={loading} />
            </FieldLabel>
          </div>

          <div className="row-form">
            <FieldLabel label="Telefone">
              <input placeholder="Telefone" value={phone} onChange={(e) => setPhone(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="Celular">
              <input placeholder="Celular" value={mobilePhone} onChange={(e) => setMobilePhone(e.target.value)} disabled={loading} />
            </FieldLabel>
          </div>

          <FieldLabel label="E-mail">
            <input placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading} />
          </FieldLabel>

          {!id && (
            <div className="row-form">
              <FieldLabel label="Senha inicial">
                <input
                  type="password"
                  placeholder="Senha inicial"
                  value={passwords.password}
                  onChange={(e) => setPasswords((current) => ({ ...current, password: e.target.value }))}
                  disabled={loading}
                />
              </FieldLabel>
              <FieldLabel label="Confirmar senha">
                <input
                  type="password"
                  placeholder="Confirmar senha"
                  value={passwords.passwordConfirmation}
                  onChange={(e) => setPasswords((current) => ({ ...current, passwordConfirmation: e.target.value }))}
                  disabled={loading}
                />
              </FieldLabel>
            </div>
          )}

          <div className="form-section-title">Endereco</div>
          <div className="row-form">
            <CepAddressLookup
              address={{ zipCode, street, number, complement, district, city, uf }}
              onZipCodeChange={setZipCode}
              onApplyAddress={aplicarEnderecoPorCep}
              disabled={loading}
            />
            <FieldLabel label="Logradouro">
              <input placeholder="Logradouro" value={street} onChange={(e) => setStreet(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="Número">
              <input placeholder="Numero" value={number} onChange={(e) => setNumber(e.target.value)} disabled={loading} />
            </FieldLabel>
          </div>
          <div className="row-form">
            <FieldLabel label="Complemento">
              <input placeholder="Complemento" value={complement} onChange={(e) => setComplement(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="Bairro">
              <input placeholder="Bairro" value={district} onChange={(e) => setDistrict(e.target.value)} disabled={loading} />
            </FieldLabel>
          </div>
          <div className="row-form">
            <FieldLabel label="Cidade">
              <input placeholder="Cidade" value={city} onChange={(e) => setCity(e.target.value)} disabled={loading} />
            </FieldLabel>
            <FieldLabel label="UF">
              <input placeholder="UF" maxLength="2" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} disabled={loading} />
            </FieldLabel>
          </div>

          <label className="check-line">
            <input type="checkbox" checked={status} onChange={(e) => setStatus(e.target.checked)} disabled={loading} />
            Fotografo ativo
          </label>

          <div className="botoes">
            <button onClick={salvar} disabled={loading}>{id ? "Atualizar" : "Salvar"}</button>
            <button className="btn-limpar" onClick={limpar} disabled={loading}>Limpar</button>
          </div>
        </div>

        <section className="cadastro-list-panel" aria-labelledby="fotografos-list-title">
        <div className="cadastro-list-heading">
          <div>
            <span className="cadastro-list-kicker">Base operacional</span>
            <h2 id="fotografos-list-title">Fotógrafos cadastrados</h2>
            <p>Busque profissionais, revise os dados e ajuste o status de acesso.</p>
          </div>
          <span className="cadastro-list-count">{lista.length} {lista.length === 1 ? "item" : "itens"}</span>
        </div>

        <div className="fotografo-filtros">
          <FieldLabel label="Buscar fotógrafo">
            <input placeholder="Buscar fotografo" value={search} onChange={(e) => setSearch(e.target.value)} />
          </FieldLabel>
          <button onClick={carregarFotografos} disabled={loading}><FiSearch aria-hidden="true" /> Buscar</button>
          <label>
            <input type="checkbox" checked={includeInactive} onChange={(e) => setIncludeInactive(e.target.checked)} />
            Mostrar inativos
          </label>
        </div>

        {loading && <p className="cadastro-loading" role="status">Carregando fotógrafos...</p>}

        <div className="cadastro-table-wrap">
        <table className="grid-cad">
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Celular</th>
              <th>Status</th>
              <th width="260">Acoes</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((fotografo) => (
              <tr key={fotografo.id}>
                <td>{fotografo.name}</td>
                <td>{fotografo.email}</td>
                <td>{fotografo.mobilePhone || fotografo.phone || "-"}</td>
                <td>{fotografo.status ? "Ativo" : "Inativo"}</td>
                <td>
                  <button onClick={() => selecionar(fotografo)} disabled={loading}>Editar</button>
                  {fotografo.status ? (
                    <button className="btn-excluir" onClick={() => alterarStatus(fotografo, false)} disabled={loading}>Inativar</button>
                  ) : (
                    <button onClick={() => alterarStatus(fotografo, true)} disabled={loading}>Restaurar</button>
                  )}
                </td>
              </tr>
            ))}
            {lista.length === 0 && !loading && (
              <tr>
                <td colSpan="5">Nenhum fotografo encontrado.</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        </section>
      </div>
    </div>
  );
}

export default CadFotografo;
